import { useState, useEffect } from "react";
import toast from "react-hot-toast";
import baseUrl from "../../../api/universalApi";

const fields = [
  { name: "company", label: "Company", type: "text" },
  { name: "amount", label: "Amount", type: "number" },
  { name: "creator_signature", label: "Creator Signature", type: "text" },
  { name: "deliverables", label: "Deliverables", type: "text" },
  { name: "paymentType", label: "Payment Type", type: "text" },
  { name: "publish_date", label: "Publish Date", type: "date" },
  { name: "start_date", label: "Start Date", type: "date" },
  { name: "end_date", label: "End Date", type: "date" },
  { name: "rep_email", label: "Rep Email", type: "email" },
  { name: "rep_signature", label: "Rep Signature", type: "text" },
  {
    name: "status",
    label: "Status",
    type: "select",
    options: ["created", "opened", "signed", "cancelled"],
  },
  { name: "signed_by", label: "Signed By", type: "text" },
  { name: "signed_at", label: "Signed At", type: "date" },
  { name: "rep_Adhar", label: "Rep Adhar", type: "text" },
  { name: "rep_phone_no", label: "Rep Phone No", type: "text" },
  { name: "rep_comments", label: "Rep Comments", type: "text" },
];

const UpdateContract = ({ campaignDetails, fetchAllCampaigns }) => {
  const [form, setForm] = useState(() => {
    const contract = campaignDetails?.contract || {};

    return fields.reduce(
      (acc, f) => {
        let val = contract[f.name] || "";
        if (f.type === "date" && val) val = val.slice(0, 10);
        return { ...acc, [f.name]: val };
      },
      {
        campaign_id: contract.campaign_id || "",
        agreement_file: contract?.agreement_file || "",
        contract_link: contract?.contract_link || "",
        file: null,
      }
    );
  });

  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");

  const handleChange = (e) => {
    const { name, type, files, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "file" ? files[0] : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMsg("");

    const formData = new FormData();
    Object.entries(form).forEach(([key, value]) => {
      if (key !== "file") {
        formData.append(key, value);
      }
    });
    if (form.file) {
      formData.append("file", form.file);
    }

    try {
      const res = await fetch(`${baseUrl}/api/agreement/update-contract`, {
        method: "POST",
        body: formData,
      });
      if (!res.ok) throw new Error("Failed to update contract");
      setMsg("Contract updated successfully!");
      toast.success("Contract updated successfully");
      fetchAllCampaigns();
    } catch (err) {
      setMsg("Error updating contract");
      toast.error("Error updating contract");
    }
    setLoading(false);
  };

  return (
    <>
      {campaignDetails?.contract?.rep_email ? (
        <>
          <div className="w-full">
            <h1 className="text-lg font-bold mb-4">Contract Management</h1>
            <form
              className="grid grid-cols-2 gap-2 items-start"
              onSubmit={handleSubmit}
              encType="multipart/form-data"
            >
              {fields.map((f) => (
                <div key={f.name} className="flex flex-col">
                  <label className="mb-1 font-medium">{f.label}</label>
                  {f.type === "select" ? (
                    <select
                      name={f.name}
                      value={form[f.name]}
                      onChange={handleChange}
                      className="border rounded px-2 py-1"
                    >
                      <option value="">Select</option>
                      {f.options.map((opt) => (
                        <option key={opt} value={opt}>
                          {opt}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <input
                      type={f.type}
                      name={f.name}
                      value={form[f.name]}
                      onChange={handleChange}
                      className="border rounded px-2 py-1"
                    />
                  )}
                </div>
              ))}

              {/* File upload input */}
              <div className="flex flex-col col-span-2">
                <label className="mb-1 font-medium">Upload Agreement File</label>
                <input
                  type="file"
                  name="file"
                  accept=".pdf,.doc,.docx"
                  onChange={handleChange}
                  className="border rounded px-2 py-1"
                />
                {(form.agreement_file || form.contract_link) && (
                  <a
                    href={form.agreement_file || form.contract_link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 text-xs mt-1"
                  >
                    View current file
                  </a>
                )}
              </div>

              {/* Drive link input */}
              <div className="flex flex-col col-span-2">
                <label className="mb-1 font-medium">Or Agreement Link</label>
                <input
                  type="url"
                  name="contract_link"
                  value={form.contract_link}
                  onChange={handleChange}
                  placeholder="https://drive.google.com/..."
                  className="border rounded px-2 py-1"
                />
              </div>

              <div className="col-span-2 flex justify-end">
                <button
                  type="submit"
                  className="mt-4 bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
                  disabled={loading}
                >
                  {loading ? "Updating..." : "Update Contract"}
                </button>
              </div>
              {msg && <div className="mt-4 text-sm">{msg}</div>}
            </form>
          </div>
        </>
      ) : (
        <>
          <div className="w-full">
            <h1 className="text-lg font-bold mb-4">No Contract Found</h1>
            <p className="text-sm text-gray-600">Please create a contract first.</p>
          </div>
        </>
      )}
    </>
  );
};

export default UpdateContract;
